// Lightweight conversion tracking. Pushes to dataLayer (GTM) and gtag (GA) if present.
// Safe no-op when analytics is not configured.

export function trackEvent(eventName, params = {}) {
  try {
    if (window.dataLayer) {
      window.dataLayer.push({ event: eventName, ...params });
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch (e) {
    /* no-op */
  }
}

export const track = {
  phoneClick: () => trackEvent("phone_click", { channel: "phone" }),
  whatsappClick: (loc = "unknown") => trackEvent("whatsapp_click", { channel: "whatsapp", location: loc }),
  emailClick: () => trackEvent("email_click", { channel: "email" }),
  formSubmit: (area = "") => trackEvent("form_submit", { channel: "quote_form", area }),
};
